import { Injectable } from '@angular/core';
import {State, Action, StateContext, Selector} from '@ngxs/store';
import { updateRouting } from './routing.action';
 
export class RoutingModel{
    
    routing:string;
 
 }
 @State<RoutingModel>({
     name: 'routingupdate',
     defaults: {
       
          routing:'',
        
      }
 })
 @Injectable()
 export class RoutingState {
 
     constructor( ) {
     }
 
     @Selector()
     static getRoutingValue(state: RoutingModel) {
         return state;
     }
    

     @Action(updateRouting)
     updateRouting({getState, patchState}: StateContext<RoutingModel>, {payload}: updateRouting) {
         const state = getState();
         patchState({
            routing:payload
            });
     }
     
    } 